export const OKTA_LOGIN_EVENT = {
  callbackError: 'Okta Login Callback Failed',
  widgetError: 'Okta Login Widget Failed',
} as const satisfies Record<string, string>;

export type OktaLoginEventName =
  (typeof OKTA_LOGIN_EVENT)[keyof typeof OKTA_LOGIN_EVENT];
